import { render, staticRenderFns } from "./MyCheckBox.vue?vue&type=template&id=622e868b&"
import script from "./MyCheckBox.vue?vue&type=script&lang=js&"
export * from "./MyCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./MyCheckBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports